import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import hasFeature from 'lumen/helpers/has-feature';

interface GeneralEmptyStateDataValidationSignature {
  Args: {};
}

const GeneralEmptyStateDataValidation = <template>
  {{#if (hasFeature "otb.data_validation")}}
    <PrismMessage
      @description={{t "my_otb.data_validation.content.1"}}
      @illustration="100x100_success"
      @title={{t "my_otb.data_validation.title"}}
      class="flex justify-center"
    >
      <:link>
        <LinkTo
          @route="hotel.settings.myotb.in-progress"
          class="prism-link text-200--regular"
        >
          {{t "overview_dashboard.otb_ss.data_validation_state.kpi.link"}}
        </LinkTo>
      </:link>
    </PrismMessage>
  {{/if}}
</template> satisfies TOC<GeneralEmptyStateDataValidationSignature>;

export default GeneralEmptyStateDataValidation;
